import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';

import EditableListTable from './EditableListTable';

type CriticalResourceRequestRow = { criticalResourceRequest: string };

const CriticalResourceRequestsTable = ({
  statusSummaryId,
  originalCriticalResourceRequests = [],
  readOnly = false,
}: {
  statusSummaryId: string;
  originalCriticalResourceRequests?: CriticalResourceRequestRow[];
  readOnly?: boolean;
}) => {
  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  return (
    <EditableListTable<CriticalResourceRequestRow>
      itemsLabel="critical resource requests"
      itemLabel="Critical Resource Request"
      testId="ics209-critical-resource-requests"
      columns={[
        {
          key: 'criticalResourceRequest',
          label: 'Critical Resource Request',
        },
      ]}
      blank={{ criticalResourceRequest: '' }}
      primaryKey="criticalResourceRequest"
      values={originalCriticalResourceRequests}
      readOnly={readOnly}
      onChange={(rows) =>
        upsertIncidentStatusSummary({
          criticalResourceRequests: rows.map(
            (row) => row.criticalResourceRequest
          ),
        })
      }
    />
  );
};

export default CriticalResourceRequestsTable;
